module.exports = __webpack_public_path__ + "static/media/27OCHA7.f665f2b1.jpg";